import CardRowSegment from "components/CardRowSegment/CardRowSegment";
import { Dot } from "components/Dot";
import React from "react";
import { Message } from "semantic-ui-react";

interface Props {
  billingDetails: server.dto.ClientBillingDetails
}

const VatRow = (props: Props) => {
  const { reverseChargeAdvice, vatNumber } = props.billingDetails;

  // vatApplicable = "yesEUBuyerHasNoValidVATNumber";

  if (reverseChargeAdvice === "yesBuyerOutsideEU") {
    return (<></>);
  }

  if (reverseChargeAdvice === "yesEUBuyerHasValidVATNumber") {
    return (<CardRowSegment className="margin-bottom" type="lined">
      <CardRowSegment.Header>{RESX.RegistrationNumber.VatNumber}</CardRowSegment.Header>
      <div className="flex">
        <div className="padding-right">
          <Dot color={vatNumber.validationHexColor} />
        </div>
        <div><strong>{vatNumber.number}</strong></div>
      </div>
      <div className="text-sublabeler">
        {RESX.Client.OurInvoicesWillBeFreeOfVAT}
      </div>
    </CardRowSegment>);
  }

  if (reverseChargeAdvice === "noEUBuyerHasNoValidVATNumber") {
    return (
      <Message color="red">
        <strong>{RESX.Client.PleaseProvideUsWithYourVATNumber}</strong>
        <div className="s1_smaller">
          {RESX.Client.PleaseContactUsIfYouHaveAVATNumber}
        </div>
      </Message>);
  }

  if (reverseChargeAdvice === "noEUBuyerInOwnCountry") {
    return (<CardRowSegment className="margin-bottom" type="lined">
      <CardRowSegment.Header>{RESX.RegistrationNumber.VatNumber}</CardRowSegment.Header>
      <div className="flex">
        <div className="padding-right">
          <Dot color={vatNumber.validationHexColor} />
        </div>
        <div><strong>{vatNumber.number}</strong></div>
      </div>
    </CardRowSegment>);
  }

  return (<Message color="red"><strong>reverseChargeAdvice {reverseChargeAdvice} not implemented.</strong><br />
    Please notify SystemOne support about this.
  </Message>);
};

export default VatRow;